import type { PatientBillingCharge } from '@/api/types/PatientApi'
import { HStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { cn } from '@/ui/utils'
import { format } from 'date-fns'
import { Fragment } from 'react'
import { Text as RNText, ScrollView, View } from 'react-native'

const FailedChargeBadge = () => (
	<RNText className="bg-red-100 border border-red-300 text-red-700 px-1 py-0.5 rounded-lg relative text-sm">
		Failed
	</RNText>
)

const BillingCharge = ({ charge }: { charge: PatientBillingCharge }) => {
	const chargeAmount = (charge.amountInCents / 100).toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
	})

	const chargeFailed = charge.status === 'FAILED'

	return (
		<HStack className="justify-between items-center px-4 gap-6">
			<Text
				size="large"
				weight="bold"
				className={cn('flex-none w-21 text-right text-palette_6')}
			>
				{chargeAmount}
			</Text>
			<Text className="flex-1 flex-wrap text-palette_6">{charge.description}</Text>
			{chargeFailed && <FailedChargeBadge />}
			<Text size="small" className="flex-none text-palette_6">
				{format(charge.date, 'M/d/yy')}
			</Text>
		</HStack>
	)
}

const BillingChargeList = ({ charges = [] }: { charges: PatientBillingCharge[] }) => {
	return (
		<ScrollView
			className="bg-palette_4 max-h-[50vh] pt-12"
			contentContainerClassName="px-4 flex lg:px-[33%] gap-3 flex-col grow pb-24"
		>
			{charges.map((charge, index) => (
				<Fragment key={charge.id}>
					<BillingCharge charge={charge} />
					{index !== charges.length - 1 && <View className="h-[2px] bg-palette_1 mx-2" />}
				</Fragment>
			))}
		</ScrollView>
	)
}

export { BillingChargeList }
